import React, { Component } from 'react';
import ItemsList from '../containers/itemsList';
import ErrorMessage from '../components/errorMessage';
import withGoTService from '../hoc/withGoTService';
import { withRouter } from 'react-router-dom';
import { BOOKS } from '../utils/constants';
import Layout from '../hoc/layout';
import { object } from 'prop-types';

class BookPage extends Component {
  static propTypes = {
    gotService: object,
  }

  state = {
    error: false,
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    const { error } = this.state
    const { history, gotService } = this.props

    if (error) {
      return <ErrorMessage />
    }

    return (
      <Layout>
        <ItemsList
          onItemSelected={itemId => history.push(itemId)}
          getData={gotService.getAllItems.bind(null, BOOKS)}
          renderItem={({ name }) => name}
        />
      </Layout>
    )
  }
}

export default withGoTService()(withRouter(BookPage))